import { Component, OnInit, Optional } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { SharedModule } from '../../../../shared/shared.module';
import { ActivatedRoute, Router } from '@angular/router';
import { HrmsService } from '../../../../services/hrms.service';

@Component({
  selector: 'app-create-shift-component',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './create-shift-component.component.html',
  styleUrls: ['./create-shift-component.component.scss']
})
export class CreateShiftComponent implements OnInit {
  isEditMode = false;
  submitted = false;
  shiftId: any;

  shiftForm = new FormGroup({
    shiftName: new FormControl('', Validators.required),
    fromTime: new FormControl<Date | null>(null, Validators.required),
    toTime: new FormControl<Date | null>(null, Validators.required),
    weekends: new FormControl('location', Validators.required),
    isActive: new FormControl(true),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
  });

  constructor(
    @Optional() public ref: DynamicDialogRef,
    @Optional() public config: DynamicDialogConfig,
    private messageService: MessageService,
    private router: Router,
    private employeeService: HrmsService,
    private routers: ActivatedRoute

  ) { }

  ngOnInit(): void {
    document.title = 'Create Shift'; 
    this.shiftForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.routers.queryParams.subscribe((params: { [x: string]: any; }) => {
      const shiftId = params['shiftId'];
      if (shiftId) {
        document.title = 'Update Shift ';
        this.isEditMode = true;
        this.shiftId = shiftId;

        this.employeeService.getShiftById(shiftId).subscribe({
          next: (shift) => {
            this.patchForm(shift);
          },
          error: (err) => {
            console.error('Failed to load shift:', err);
            this.router.navigate(['/home/list-shift']);
          }
        });
      } else {

      }
    });

  }

  patchForm(shift: any) {
    this.shiftForm.patchValue({
      shiftName: shift.shiftName,
      fromTime: this.convertTimeStringToDate(shift.fromTime),
      toTime: this.convertTimeStringToDate(shift.toTime),
      weekends: shift.weekends || 'location',
      isActive: shift.isActive
    });
  }

  convertTimeStringToDate(timeString: string): Date | null {
    if (!timeString) return null;

    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds || 0, 0);
    return date;
  }

  onSubmit() {
    if (this.isEditMode) {
      this.updateEmployeeShift(this.shiftForm.value);
    } else {
      this.createEmployeeShift(this.shiftForm.value);
    }
  }


  createEmployeeShift(data: any) {
    this.submitted = true;
    if (!this.validateForm()) return;

    const payload = {
      ...data,
      fromTime: this.formatTime(data.fromTime),
      toTime: this.formatTime(data.toTime),
      IsActive: true
    };

    this.employeeService.createEmployeeShift(payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Shift saved successfully.' });
        setTimeout(() => this.router.navigate(['/home/list-shift']), 1000);
      },
      error: err => console.error('Error saving shift:', err)
    });
  }

  private formatTime(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }


  cancel() {
    this.router.navigate(['/home/list-shift']);
  }

  get formControls() {
    return this.shiftForm.controls;
  }

  updateEmployeeShift(data: any) {
    this.submitted = true;
    if (!this.validateForm()) return;

    const payload = {
      ShiftId: this.shiftId,
      ShiftName: data.shiftName,
      FromTime: this.formatTime(data.fromTime),
      ToTime: this.formatTime(data.toTime),
      Weekends: data.weekends,
      IsActive: data.isActive,
      UpdatedBy: localStorage.getItem('username'),
    };

    this.employeeService.updateShift(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Shift updated successfully.'
        });
        setTimeout(() => this.router.navigate(['/home/list-shift']), 1000);
      },
      error: error => {
        console.error('Error updating shift:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update shift.'
        });
      }
    });
  }



  validateForm() {
    let isValid = true;
    if (this.shiftForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }
}
